import React from 'react';

export function FeatureHighlight({
  icon,
  title,
  description,
  className = '',
  ...props
}) {
  return (
    <div className={`flex flex-col items-center text-center p-6 bg-surface border border-accent/30 rounded-2xl shadow-lg ${className}`} {...props}>
      <div className="text-5xl mb-3 text-accent">{icon}</div>
      <h4 className="font-heading text-2xl font-bold text-primary mb-2">{title}</h4>
      <p className="text-text-secondary text-base">{description}</p>
    </div>
  );
}

export default FeatureHighlight;
